import React, {useContext} from "react";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import BlockHeader from "component/BlockHeader/BlockHeader";
import { UserContext } from "..";
import { useState } from "react";
import { useEffect } from "react";
import api from "api";
import _ from "lodash";
import { ProficiencyLevels } from "component/EditSkill";
import "./index.scss";
import { PageCredential } from "component/PageCredential";

const PageProfileUserSkill = connect(stateMap)(props => {
    const currentUserContext = useContext(UserContext);
    const [skills, setSkills] = useState([]);
    const [skillload, setSkillLoad] = useState(true);
    

    useEffect(() => {
        if(!props.auth.user)
        {
            return;
        }

        if(!currentUserContext.profile)
        {
            return;
        }

        setSkillLoad(true);

        api('/Profile/Skill', 'get', {
            user_id : currentUserContext.profile.UserID
            ,posts_per_page : -1
        }, 'Bearer ' + props.auth.token)
            .then(response => {
                setSkills(response.skill);

                setSkillLoad(false);
            })

        
    }, [props.auth.user]);


    
    return (
        <div className="profile-user-skills">
            <PageCredential title={`${currentUserContext.profile.UserDisplayName} | Skills`}/>
            <div className="container">
                <div className="w-640 mx-auto relative">
                    <BlockHeader title="Skills" desc={`${currentUserContext.profile.UserDisplayName} Skill`}/>
                    <ul className="skills-list">
                        {
                            !skillload && skills.map(skill => (
                                <li className="skill-wrapper relative" key={skill.UserSkillID}>
                                    <div className="skill-list">
                                        <span className="skill-name bold text-sm mb-md block">{skill.SkillName}</span>
                                        <ProficiencyLevels proficiency={skill.Proficiency}/>
                                    </div>
                                </li>
                            ))
                        }
                        {
                            skillload && <div className="skeleton"></div>
                        }
                    </ul>
                </div>
            </div>
        </div>
    )
});

export default PageProfileUserSkill;